import { Question, SeveralOptionRenderProps } from "@common";
import { blue } from "@mui/material/colors";
import { green, pink, purple } from "../config";
import { DiscussionSlideData } from "../config/discussionSlideData";
import {
  AnswerStat,
  answerStatsTypes,
  BarChartStatsConfig,
  Stat,
  StatConfig,
} from "../interfaces/answerStats.interface";
import {
  playerBarAnswerStatsConfig,
  playerBubblesAnswerStatsConfig,
} from "../interfaces/question.interface";

const getStats = (config: StatConfig): Stat => {
  if (config.type === answerStatsTypes.bubbles) {
    return {
      type: answerStatsTypes.bubbles,
      values: { val1: 0, val2: 0, val3: 0 },
      config: config,
    };
  } else if (config.type === answerStatsTypes.horizontalBar) {
    return {
      type: answerStatsTypes.horizontalBar,
      values: { bar1: 0, bar2: 0, bar3: 0, bar4: 0, bar5: 0 },
      config: config,
    };
  } else if (config.type === answerStatsTypes.wordCloud) {
    return {
      type: answerStatsTypes.wordCloud,
      values: { comments: [] },
      config: config,
    };
  } else {
    return {
      type: answerStatsTypes.barChart,
      values: { bar1: 0, bar2: 0, bar3: 0, bar4: 0, bar5: 0 },
      config: config,
    };
  }
};

export const createAnswerStatForQuestion = (question: Question): AnswerStat | undefined => {
  if (question.renderTemplate === "several-option") {
    const config: BarChartStatsConfig = {
      title: "Vad alla har svarat: !!!",
      type: answerStatsTypes.barChart,
      labelAndColorForBar1: {
        label: (question.renderProps as SeveralOptionRenderProps).option1Text.sv,
        brightColor: blue[200],
        mainColor: blue[400],
        darkColor: blue[500],
      },
      labelAndColorForBar2: {
        label: (question.renderProps as SeveralOptionRenderProps).option2Text.sv,
        brightColor: green[300],
        mainColor: green[500],
        darkColor: green[600],
      },
      labelAndColorForBar3: {
        label: (question.renderProps as SeveralOptionRenderProps).option3Text.sv,
        brightColor: pink[300],
        mainColor: pink[500],
        darkColor: pink[600],
      },
      labelAndColorForBar4: {
        label: (question.renderProps as SeveralOptionRenderProps).option4Text.sv,
        brightColor: purple[400],
        mainColor: purple[700],
        darkColor: purple[800],
      },
    };

    return createAnswerStat(answerStatsTypes.barChart, config);
  } else {
    return createAnswerStat(answerStatsTypes.bubbles);
  }
};

export const createAnswerStatForDiscussionSlide = (
  discSlideData: DiscussionSlideData
): AnswerStat | undefined => {
  return createAnswerStat(discSlideData.statConfig.type, discSlideData.statConfig);
};

export const createAnswerStat = (
  type: answerStatsTypes,
  config?: StatConfig | undefined
): AnswerStat | undefined => {
  if (config === undefined) {
    if (type === answerStatsTypes.bubbles) {
      config = playerBubblesAnswerStatsConfig;
    } else if (type === answerStatsTypes.horizontalBar) {
      config = playerBarAnswerStatsConfig;
    } else {
      console.error("Couldn't find a suitable answer stat config");
    }
  }

  if (config === undefined) return undefined;
  if (type !== config?.type) {
    console.error("Config type didn't match parameter type.");
    return undefined;
  }

  const answerStat: AnswerStat = {
    stats: getStats(config),
    amountNotAnswered: 0,
    amountCorrect: 0,
    amountIncorrect: 0,
    amountReadyForNextQuestion: 0,
    comments: [],
  };
  return answerStat;
};
